import { render, staticRenderFns } from "./APPVersionInfo.vue?vue&type=template&id=2bfcc8ba&scoped=true"
import script from "./APPVersionInfo.vue?vue&type=script&lang=js"
export * from "./APPVersionInfo.vue?vue&type=script&lang=js"
import style0 from "./APPVersionInfo.vue?vue&type=style&index=0&id=2bfcc8ba&prod&lang=stylus&scoped=true"
import style1 from "./APPVersionInfo.vue?vue&type=style&index=1&id=2bfcc8ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfcc8ba",
  null
  
)

export default component.exports